import { getSectors } from "services/generalSettings.services";
import { useQuery  } from "react-query";

export const useSectors = () => {
  return useQuery("sectors", getSectors);
};
